import { Card, Checkbox, Space } from 'antd';
import ImportTitle from './ImportTitle';
import React, {useState} from "react";

const ImportWorkGalleryStep = ({ accountData, selectedFields, onFieldSelection }) => {
    const [assets, setAssets] = useState(TB.cloneDeep(accountData.assets || []))

    return (
        <div className="py-6">
            <ImportTitle
                title="Work Gallery"
                description="Select the assets you'd like to import to your work gallery"
            />

            <Card title={
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <i className="fas fa-images" />
                        <span>Assets ({assets?.length || 0})</span>
                    </div>
                    <Space>
                        <Checkbox
                            checked={assets?.every((_, idx) => selectedFields?.assets?.[idx])}
                            onChange={(e) => {
                                const newValue = {};
                                assets?.forEach((_, idx) => {
                                    newValue[idx] = e.target.checked;
                                });
                                onFieldSelection('assets', newValue);
                            }}
                        >
                            <span className="text-xs text-gray-500">Select All</span>
                        </Checkbox>
                    </Space>
                </div>
            }>
                <Space direction="horizontal" size={8} className="grid grid-cols-3 gap-x-4 gap-y-4 items-start">
                    {assets?.map((asset, index) => (
                        <div key={`asset-${index}-${TB.slugify(asset.path)}`} className="flex items-start gap-4 flex-row" >
                            <Space>
                                <Checkbox
                                    checked={selectedFields?.assets?.[index]}
                                    onChange={(e) => onFieldSelection('assets', {
                                        ...(selectedFields?.assets || {}),
                                        [index]: e.target.checked
                                    })}/>
                            </Space>
                            <div style={{ flex: 1 }}>
                                <div className="flex flex-row items-start flex-wrap gap-3 mb-2">
                                    <div className="flex flex-col gap-2">
                                        {/* <p className="m-0">{asset.caption}</p> */}

                                        <div className="border p-1 h-[104px] w-[104px]">
                                            <img src={`${asset.path}`} alt={asset.caption} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Space>
            </Card>
        </div>
    );
};

export default ImportWorkGalleryStep;